import React, { forwardRef, useState } from 'react';
import styled, { css } from 'styled-components';
import TippyReact from '@tippyjs/react';
import 'tippy.js/themes/light.css';
import 'tippy.js/dist/tippy.css';

const avoidOverflowHidden = (props) =>
  !!props?.avoidOverflowHidden &&
  css`
    overflow: visible;
  `;

const tooltipStyles = css`
  && {
    .tippy-content {
      overflow: hidden;
      overflow-y: auto;
      padding: 0;
      font-size: 1.2rem;
      ${avoidOverflowHidden}
    }
  }
`;

const Tooltip = (props) => {
  return <TippyReact {...props} className={props?.className} ref={props.innerRef || null} />;
};

const Tippy = styled(Tooltip)`
  ${tooltipStyles}
`;

const LazyTippy = forwardRef((props, ref) => {
  const [mounted, setMounted] = useState(false);

  const lazyPlugin = {
    fn: () => ({
      onMount: () => setMounted(true),
      onHidden: () => setMounted(false),
    }),
  };

  const computedProps = { ...props };

  computedProps.plugins = [lazyPlugin, ...(props.plugins || [])];

  if (props.render) {
    computedProps.render = (...args) => (mounted ? props.render(...args) : '');
  } else {
    computedProps.content = mounted ? props.content : '';
  }

  return <Tippy {...computedProps} innerRef={ref} />;
});

export { LazyTippy };
export default Tippy;
